import { useEffect, useState } from 'react'

// local imports
import FavoritesService from 'service/FavoritesService'
import { IFavoriteCampusServices } from 'types/FavoritesType'

export default function useGetFavoriteCampusServices() {
  const [list, setList] = useState<IFavoriteCampusServices[] | []>([])
  const [loading, setLoading] = useState(false)

  const getList = (showLoading = false) => {
    if (showLoading) setLoading(true)

    FavoritesService.getFavoriteCampusServicesList()
      .then((r) => setList(r.data))
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }

  useEffect(() => getList(true), [])

  return { list, setList, loading }
}
